export default {"src":"/_next/static/media/midjourney.b6b21ce8.svg","height":2577,"width":2577,"blurWidth":0,"blurHeight":0};